import React from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import CompactSection from 'src/presentation/components/pages/integrations/editorComponents/CompactSection';
import { Row } from 'src/presentation/components/forms/Layout';
import {
  MaskedField,
  WrappedField,
} from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';

function renderSmileConfiguration(onChange: (attr: string) => ChangeHandler, maskedFields: string[]): JSX.Element {
  return (
    <>
      <CompactSection
        description={`The Smile app enriches your customer pages with customer details such as loyalty
        information pulled from your Smile instance.`}
      >
        <Row>
          <WrappedField
            attr="name"
            label="Name"
            placeholder="App Name"
            description="This is the name that will be displayed throughout Gladly"
            data-aid="smile-integration-name"
            autoFocus={true}
            onChange={onChange('name')}
          />
        </Row>
        <Row>
          <MaskedField
            attr="secrets.token"
            label="Smile Private Token"
            description="This field is used to authentificate Smile requests"
            data-aid="smile-token"
            onChange={onChange('secrets.token')}
            showClearButton={maskedFields.includes('token')}
            isMasked={maskedFields.includes('token')}
          />
        </Row>
      </CompactSection>
    </>
  );
}

export default renderSmileConfiguration;
